import * as EditorActions from "./editorActions";

export default EditorActions;
